import React from 'react';

export const chartTooltipStyle: React.CSSProperties = {
  borderRadius: 12,
  border: '1px solid rgba(0, 75, 77, 0.12)',
  boxShadow: '0 8px 24px -8px rgba(0, 75, 77, 0.15)',
};
